// Mensajes de validación estandarizados para formularios

export const VALIDATION_MESSAGES = {
  // Campos requeridos
  required: {
    nombres: "Debes ingresar tu nombre",
    primerApellido: "Debes ingresar tu primer apellido",
    segundoApellido: "Debes ingresar tu segundo apellido",
    rut: "Debes ingresar el RUT",
    email: "Debes ingresar un correo",
    telefono: "Debes ingresar un número de celular",
    phoneNumber: "Debes ingresar un número de celular",
    direccion: "Debes ingresar una dirección",
    region: "Debes seleccionar una región",
    ciudad: "Debes seleccionar una ciudad",
    comuna: "Debes seleccionar una comuna",
    colegio: "Debes seleccionar un colegio",
    añoGraduacion: "Debes seleccionar un año",
    promedio: "Debes ingresar tu promedio",
    fechaNacimiento: "Debes ingresar tu fecha de nacimiento",
    genero: "Debes seleccionar tu género"
  },

  // Validaciones de formato
  format: {
    email: "Debes ingresar un correo válido",
    rut: "El RUT ingresado no es válido",
    telefono: "El número debe tener 9 dígitos (después del +56)",
    phoneNumber: "El número debe tener 9 dígitos (después del +56)",
    promedio: "El promedio debe estar entre 0,0 y 7,0",
    fecha: "Debe ingresar la fecha correctamente"
  },

  // Validaciones de longitud
  length: {
    telefono: {
      min: "El número de celular debe tener 9 dígitos",
      max: "El número de celular debe tener 9 dígitos"
    },
    phoneNumber: {
      min: "El número de celular debe tener 9 dígitos",
      max: "El número de celular debe tener 9 dígitos"
    },
    email: {
      min: "Debes ingresar un correo válido"
    },
    nombres: {
      min: "Debes ingresar el nombre completo"
    }
  },

  // Validaciones de tipo
  type: {
    letras: "Solo se permiten letras",
    numeros: "Solo se permiten números",
    telefono: "El número de celular debe tener solo dígitos"
  }
};

// Expresiones regulares estandarizadas
export const VALIDATION_REGEX = {
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
  phone: /^[0-9]{9}$/,
  rut: /^[0-9]{1,2}\.[0-9]{3}\.[0-9]{3}-[0-9kK]$/,
  letras: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/,
  numeros: /^[0-9]+$/
};

// Configuración de validación
export const VALIDATION_CONFIG = {
  phone: {
    minLength: 9,
    maxLength: 9,
    pattern: VALIDATION_REGEX.phone
  },
  email: {
    minLength: 8,
    pattern: VALIDATION_REGEX.email
  }
};
